import { render, staticRenderFns } from "./OnLive.vue?vue&type=template&id=308955f4&scoped=true&"
import script from "./OnLive.vue?vue&type=script&lang=js&"
export * from "./OnLive.vue?vue&type=script&lang=js&"
import style0 from "./OnLive.vue?vue&type=style&index=0&id=308955f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308955f4",
  null
  
)

export default component.exports